import {FC, useRef, useEffect, useState} from 'react'
import {shallowEqual, useSelector, connect, useDispatch, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getUserByToken, refresh_token as refresh_tokenFunction} from './AuthCRUD'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
    const didRequest = useRef(false)
    const dispatch = useDispatch()
    const [showSplashScreen, setShowSplashScreen] = useState(true)
    const token = useSelector<RootState>(({auth}) => auth.token, shallowEqual)
    const pvdId = useSelector<RootState>(({auth}) => auth.representative_id, shallowEqual) as number
    const refresh_token = useSelector<RootState>(({auth}) => auth.refresh_token, shallowEqual)

    useEffect(() => {
        const requestUser = async () => {
            try {
                if (!didRequest.current) {
                    const {data} = await getUserByToken(pvdId)
                    dispatch(props.fulfillUser(data.data.user))
                }
            } catch (error) {
                console.error(error)
                if (!didRequest.current) {
                    try {
                        const {data} = await refresh_tokenFunction(String(refresh_token))
                        dispatch(props.refresh_token(data.access_token, data.refresh_token))
                        if (data.access_token) {
                            const userData = await getUserByToken(pvdId)
                            dispatch(props.fulfillUser(userData.data.data.user))
                        }
                    } catch (error) {
                        console.error(error)
                        dispatch(props.logout())
                    }
                }
            } finally {
                setShowSplashScreen(false)
            }

            return () => (didRequest.current = true)
        }

        if (token) {
            requestUser()
        } else {
            dispatch(props.logout())
            setShowSplashScreen(false)
        }
        // eslint-disable-next-line
    }, [])

    return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
